// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3TOQL","content":"LoadingAlert_content__2NPYL"};